













































































































































































import { Component, Vue } from "vue-property-decorator";
import { storeComplaintResponse } from "@/store/modules/ComplaintResponseStore";
import ComplaintResponseSvc from "@/services/ComplaintResponseService";
import ComplaintResponseForm from "@/components/complaint-response/ComplaintResponseForm.vue";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import moment from "moment";

@Component({
  components: { ComplaintResponseForm },
})
export default class ComplaintResponseList extends Vue {
  storeModule = storeComplaintResponse;

  showDetail = false;
  selectedId: number | null = null;

  filterTglDari = moment().startOf("month").format("YYYY-MM-DD");
  filterTglSampai = moment().format("YYYY-MM-DD");
  filterGrading: string | null = null;
  filterStatus: string | null = null;
  filterJenis: string | null = null;
  filterSearch = "";

  dialogDelete = false;
  itemToDelete: any = null;

  gradingOptions = [
    { text: "Merah", value: "merah" },
    { text: "Kuning", value: "kuning" },
    { text: "Hijau", value: "hijau" },
  ];

  statusPenangananOptions = [
    { text: "Tercapai", value: "tercapai" },
    { text: "Tidak Tercapai", value: "tidak_tercapai" },
    { text: "Belum Ditindaklanjuti", value: "belum_ditindaklanjuti" },
  ];

  jenisOptions = [
    { text: "Lisan", value: "lisan" },
    { text: "Tertulis", value: "tertulis" },
    { text: "Media Sosial", value: "media_sosial" },
  ];

  headers = [
    { text: "Tgl/Nomor", value: "tanggal_terima", width: "120px" },
    { text: "Pelapor", value: "pelapor", width: "150px" },
    { text: "Jenis", value: "jenis_komplain", width: "100px" },
    { text: "Unit", value: "unit_nama", width: "120px" },
    { text: "Grading", value: "grading", align: "center", width: "90px" },
    { text: "Waktu T0/T1", value: "waktu", width: "140px" },
    { text: "Durasi", value: "durasi", width: "110px" },
    { text: "Status Tanggap", value: "status_penanganan", align: "center", width: "110px" },
    { text: "Status TTD", value: "status", align: "center", width: "110px" },
    { text: "Aksi", value: "actions", sortable: false, align: "center", width: "120px" },
  ];

  mounted() {
    this.loadData();
  }

  loadData() {
    this.storeModule.loadEvents({
      tgl_dari: this.filterTglDari,
      tgl_sampai: this.filterTglSampai,
      grading_final: this.filterGrading,
      status_penanganan: this.filterStatus,
      jenis_komplain: this.filterJenis,
      search: this.filterSearch,
    });
  }

  tambahBaru() {
    this.selectedId = null;
    this.showDetail = true;
  }

  lihat(item: any) {
    this.selectedId = item.id;
    this.showDetail = true;
  }

  kembaliKeList() {
    this.showDetail = false;
    this.selectedId = null;
    this.loadData();
  }

  onSaved() {
    this.loadData();
  }

  printPdf(id: number) {
    ComplaintResponseSvc.printPdf(id);
  }

  bisaHapus(item: any): boolean {
    if (!item.is_locked) return true;
    const slots = [
      { ditandatangani: item.signed_petugas_at, penandaTanganId: item.petugas_penerima_id },
      { ditandatangani: item.signed_ka_unit_at, penandaTanganId: item.ka_unit_user_id },
      { ditandatangani: item.signed_komite_mutu_at, penandaTanganId: item.komite_mutu_user_id }
    ];
    if (!slots.some(slot => !!slot.ditandatangani)) return false;
    return !alasanTtdMengunciHapus(item.creator_user_id, slots, userModule.user?.id);
  }

  confirmDelete(item: any) {
    if (!this.bisaHapus(item)) return;
    this.itemToDelete = item;
    this.dialogDelete = true;
  }

  async doDelete() {
    if (!this.itemToDelete) return;
    try {
      await ComplaintResponseSvc.destroy(this.itemToDelete.id);
      this.dialogDelete = false;
      this.itemToDelete = null;
      this.loadData();
    } catch {
      // error alert handled in service
    }
  }

  // ==================== FORMATTERS ====================
  formatDate(val: string) {
    return val ? moment(val).format("DD/MM/YYYY") : "-";
  }
  formatDateTime(val: string) {
    return val ? moment(val).format("DD/MM HH:mm") : "-";
  }
  formatShift(val: string) {
    const m: any = { pagi: "Pagi", siang: "Siang", malam: "Malam" };
    return m[val] || val;
  }
  pelaporLabel(val: string) {
    const m: any = {
      pasien: "Pasien",
      keluarga: "Keluarga",
      pengunjung: "Pengunjung",
      anonim: "Anonim",
    };
    return m[val] || val;
  }
  jenisLabel(val: string) {
    const m: any = {
      lisan: "Lisan",
      tertulis: "Tertulis",
      media_sosial: "Media Sosial",
    };
    return m[val] || val;
  }
  durasiColor(item: any) {
    if (item.status_penanganan === "tercapai") return "green--text";
    if (item.status_penanganan === "tidak_tercapai") return "red--text";
    return "";
  }
}
